<script lang="ts">  import { m } from '$lib/paraglide/messages';

  import { AssetType, getAssetFromUrl } from '$lib/utils/asset';
  import filtersIcon from '$lib/assets/search/filters.svg';
  import { translation } from '$lib/locale/locale';
  import { page } from '$app/state';

  const { langHref } = translation();

  let {
    type,
    showFiltersSheet = $bindable(),
    filtersCount = $bindable(),
    onOrderBy,
  }: {
    type: AssetType;
    showFiltersSheet: boolean;
    filtersCount: number;
    onOrderBy: (orderBy: string) => void;
  } = $props();

  let orderBy = $state('date');

  function setOrderBy(newValue: string) {
    if (orderBy !== newValue) {
      orderBy = newValue;
      onOrderBy(newValue);
    }
  }
</script>

<div class="tabs mobile-only">
  <div class="assets">
    <a href={langHref('/royalty-free-music')} class:active={getAssetFromUrl(page.url.pathname) === AssetType.Track}>
      {m['header.browse.music']()}
    </a>
    <a href={langHref('/sound-effects')} class:active={getAssetFromUrl(page.url.pathname) === AssetType.SFX}>
      {m['header.sfx']()}
    </a>
    <a href={langHref('/intros')} class:active={getAssetFromUrl(page.url.pathname) === AssetType.Intro}>
      {m['header.intros']()}
    </a>
  </div>

  {#if type === AssetType.Track || type === AssetType.SFX}
    <button class="sort-controls" onclick={() => (showFiltersSheet = true)} aria-label={m['search.collapse-filters']()}>
      <img src={filtersIcon} class="filters-icon" alt="" loading="lazy" aria-hidden="true" />
      {m['search.filters']()}
      {#if filtersCount > 0}
        <span class="total-count">({filtersCount})</span>
      {/if}
    </button>
  {/if}
</div>

<style>
  .tabs {
    height: 56px;
    border-bottom: 1px solid #efeff1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: -24px;
    margin-right: -24px;
  }

  @media (max-width: 1050px) {
    .tabs {
      margin-left: -16px;
      margin-right: -16px;
    }
  }

  .assets {
    padding-left: 20px;
  }

  .assets a {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: var(--text-secondary);
    padding: 19px 19px;
  }

  .assets a:hover {
    text-decoration: none;
    color: var(--text-primary);
  }

  .assets a.active {
    color: var(--text-primary);
    border-bottom: 1px solid var(--magic-potion);
  }

  .sort-controls {
    display: flex;
    padding-right: 20px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: var(--text-secondary);
    margin-left: auto;
  }

  .filters-icon {
    margin-right: 8px;
    width: 20px;
    height: 20px;
    object-fit: contain;
  }

  .total-count {
    margin-left: 6px;
  }

  .mobile-only {
    display: none;
  }

  @media (max-width: 1050px) {
    .mobile-only {
      display: flex;
    }
    .tabs {
      height: 44px;
    }

    .assets a {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: var(--text-secondary);
      padding: 13px 15px;
    }
  }
</style>
